import jadeTheme from '@stone-payments/jade-design-tokens/cjs/stone';
import styled from 'styled-components';

export const HeaderContent = styled.div`
  margin-bottom: ${jadeTheme.global.space[250]};
  margin-top: ${jadeTheme.global.space[250]};
  margin-left: ${jadeTheme.global.space[900]};
  margin-right: ${jadeTheme.global.space[900]};
  display: flex;
  justify-content: space-between;
  align-items: center;
  top:0;

  @media screen and (max-width: 495px) {
    margin-left: ${jadeTheme.global.space[200]};
    margin-right: ${jadeTheme.global.space[200]};
  }

  @media print {
    margin-top: ${jadeTheme.global.space[100]};
    margin-bottom: ${jadeTheme.global.space[100]};
  }
`

export const HeaderContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid ${jadeTheme.theme.color.border.low};
  background: ${jadeTheme.theme.color.background.surface};
`
